module.exports = __webpack_public_path__ + "img/roboto-medium.cd30d55.svg";